import React, { useEffect, FC, useState } from "react";
import { Table, Button, Input, Tooltip, Checkbox, Divider, CheckboxProps, Row, Col, } from "antd";
import { YHModal } from "@/components/YHModal";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { RouterParamType } from "@/model/navModel";
import { YhBut } from "@/components/YhButton";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { usePurchaseEnquiryDetailsModel } from "./purchaseEnquiryDetailsModel";
import { formatNum } from "@/utils/utils";
import useGlobalModel, { transOptions } from "@/model/globalModel";
import { ISelectOptions } from "@/types/ScmTypes";
import { ISelectOption } from "@/components/YhFormBox/Types";
import YhTootip from "@/components/YhTootip";
import { BankFilled, BankTwoTone } from "@ant-design/icons";


export const AddSupplierModal: FC<RouterParamType> = ({ id, mode }) => {
    const { addSupplierVisible: visible,
        setAddDataSource, updatEditFormVal, returnList,
        transformsToPoDetailList, updateAddFormVal,
        detailAddForm, detailEditForm, detailLookForm,
        // supplierList, setSupplierList,
        setTopButsControl, setAddSupplierVisible,
    } = usePurchaseEnquiryDetailsModel();
    const CheckboxGroup = Checkbox.Group;
    const typeForm: any = {
        add: { ...detailAddForm },
        edit: detailEditForm,
        look: detailLookForm
    }
    const { beShopDs, supplieAllList, shopAndOrg: { shopId, shopCode, shopName } } = useGlobalModel()
    const [plainOptions, setPlainOptions] = useState<any[]>([]);
    const [checkedList, setCheckedList] = useState<any[]>([]);
    useEffect(() => {
        if (visible) {
            setCheckedList(supplieAllList.filter((list: any) => list.typeCode == returnList[typeForm[mode].approveTypeCode]).map((item: any) => item.name))
            setPlainOptions(typeForm[mode]?.supplierList?.map((item: any) => item.name));
        }
    }, [visible])
    const onOK = async () => {
        let newList: any = []
        supplieAllList.map((item: any) => {
            if (plainOptions.includes(item.name)) {
                newList.push({ code: item.code, name: item.name, type: item.typeCode, userCode: item.userCode, })
            }
        })
        mode === "add" ? updateAddFormVal({ supplierList: newList }) : updatEditFormVal({ supplierList: newList });
        onCancel()
        setTopButsControl(true)
    }
    const onCancel = () => {
        setAddSupplierVisible(false);

    };

    const checkAll = plainOptions.length === checkedList.length;
    const indeterminate = checkedList.length > 0 && checkedList.length < plainOptions.length;

    const onChangeList = (list: any) => {
        setPlainOptions(list);
    };

    const onCheckAllChange: CheckboxProps['onChange'] = (e) => {
        setPlainOptions(e.target.checked ? checkedList : []);
    };
    return <YHModal
        visible={visible}
        onOk={onOK}
        onCancel={onCancel}
        title="选择供应商"
        width={500}
        bodyHeight={450}
        showFooter={true}
    >
        <div style={{ margin: '20px' }}>
            <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}>
                选择全部供应商
            </Checkbox>
            <Divider style={{ margin: '8px 0', height: '3px' }}
            />
            <div style={{ marginTop: '8px' }}>
                <CheckboxGroup className="custom-checkbox-group" options={checkedList} value={plainOptions} onChange={onChangeList} />
            </div>
        </div>
    </YHModal>
}
const styles = `
.custom-checkbox-group .ant-checkbox-group-item {
    width: 100% !important;
}
`;
// 将样式注入到文档中
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);